/* eslint-disable max-len */
import React from 'react'

export default function AcceptRejectBlock({setacceptRejectPopup}) {
    return (
        <div className="w-full flex" >
            <button type="button" 
                onClick={()=>setacceptRejectPopup('Reject')}
                className="w-[50%] h-9 font-semibold text-sm text-[#6E1417] rounded-lg" style={{border:'1px solid #800005',borderColor:'#EDA3A6'}}  data-bs-toggle="modal" data-bs-target="#RejectModal">
                Reject
            </button>
            <button onClick={()=>setacceptRejectPopup('Accept')} type="button" className="bg-[#CFF7BE] w-[50%] ml-5 h-9 font-semibold text-sm text-[#206C00] rounded-lg" style={{border:'1px solid #206C00'}}  data-bs-toggle="modal" data-bs-target="#ActionModal">
                Accept
            </button>
        </div>
    )
}
